import Api from "@/services/Api";

export default {
    async getSectors() {
        var sectors = [];
        await Api(true).post('sector/list', {})
            .then(r => {
                sectors = r.data;
            });
        return sectors;
    },

    async createSector(sector) {
        const r = await Api(true).post('sector/create', sector);
        const data = r.data;
        return Array.isArray(data) ? (data[0] ?? null) : data;
    },

    async editSector(sector) {
        const r = await Api(true).post('sector/edit', sector);
        const data = r.data;
        return Array.isArray(data) ? (data[0] ?? null) : data;
    }
};
